import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { request } from '../../../../config';
import lastOperationsIcon from '../../img/last-operations-icon.png';
import { getFormatedDate } from '../../../../helpers/fotmatDate';
import POSdetailsModal from '../../../../copms/Modal/POSdetailsModal';
import transferConfirmation from './../../img/transfer-confirmation.svg';

class List extends Component {
    state = {
        open: false,
        fullname: "",
        email: "",
        message: "",
        list: []
    }

    getOrders = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getOrdersRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("posTerminal/getOrders", getOrdersRequestBody))
            .then(res => res.text())
            .then((getOrdersResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getOrdersResponse = JSON.parse(getOrdersResponseJSON);
                if (getOrdersResponse.status.statusCode !== 1) {
                    if (getOrdersResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getOrdersResponse.status.statusCode));
                    }
                }
                this.setState({ list: getOrdersResponse.orders || [] });
                this.props.updateAppState('isLoadingTransparentBackground', false);
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getOrder = (orderId) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getOrderRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            orderId
        }
        fetch(request("posTerminal/getOrder", getOrderRequestBody))
            .then(res => res.text())
            .then((getOrderResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getOrderResponse = JSON.parse(getOrderResponseJSON);
                if (getOrderResponse.status.statusCode !== 1) {
                    if (getOrderResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getOrderResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.setState({ openDetails: true, item: getOrderResponse.order })
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    componentDidMount() {
        this.getOrders();
    }

    render() {
        let { t, history } = this.props;
        let { openDetails, list, item } = this.state;

        return (
            <Fragment>
                <POSdetailsModal open={openDetails} item={item} closeFunction={() => this.setState({ openDetails: false })} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('orders')}</h2>
                    </div>
                </div>
                <div className="dashboard-payment-container">
                    <div className="dashboard-payment-container-data-section">
                        <div className="dashboard-transfer-list-header">
                            <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                                {/* <NavLink exact to="/dashboard/orders/credit" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("credit")}</NavLink> */}
                                <NavLink exact to="/dashboard/orders/plastic-card" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Plastic card")}</NavLink>
                                {localStorage.getItem('checkResident') === "1" && localStorage.getItem("isAsan") === "true" &&
                                    <NavLink exact to="/dashboard/orders/account" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Account")}</NavLink>}
                                {localStorage.getItem('compId') &&
                                    <NavLink to="/dashboard/orders/pos" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("POS Terminal Order")}</NavLink>}
                            </div>
                        </div>
                        <div className="dashboard-contact-section">
                            <div className="d-flex justify-content-between align-items-center my-2">
                                <h5>{t('orders')}</h5>
                                <button className="dashboard-contact-section-button" onClick={() => history.push('/dashboard/orders/pos/order')}>{t('Apply')}</button>
                            </div>
                            {list.length === 0 ?
                                <div className="dashboard-last-operations-section-content mt-5">
                                    <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                    <p className="dashboard-last-operations-section-content-status">{t('You have no requests')}</p>
                                </div>
                                :
                                <table className="dashboard-contact-section-table w-100">
                                    <thead>
                                        <tr>
                                            <td>{t('Order Number')}</td>
                                            <td>{t('Order Date')}</td>
                                            <td>{t('Its status')}</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map(item =>
                                            <tr onClick={e => this.getOrder(item?.id)}>
                                                <td>{item?.orderNumber}</td>
                                                <td>{getFormatedDate(item?.systemDate, 'dd.mm.yyyy')}</td>
                                                {item?.status ?
                                                    <td>
                                                        <span style={{ width: '8px', height: '8px', display: 'inline-block', marginRight: 7, borderRadius: '50%', backgroundColor: item?.statusId == 1 ? "#FFAB24" : item?.statusId == 5 ? "#39C045" : item?.statusId == 6 ? "#FF3A3A" : "#0179D2" }}></span>
                                                        {item?.status}
                                                    </td>
                                                    : <td></td>}
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                    <div className="dashboard-payment-container-confirmation-section">
                        <div className="dashboard-payment-container-confirmation-section-header">
                            <h3 className="dashboard-payment-container-confirmation-section-header-title">{t('What happens after you place your order')}</h3>
                        </div>
                        <div className="dashboard-payment-container-confirmation-section-content">
                            <img src={transferConfirmation} alt="img" className="dashboard-payment-container-confirmation-section-content-image" />
                            <div className="dashboard-payment-container-confirmation-section-content-description">
                                <p>{t('order content')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
export default translate("translation")(List);